import {
  ApartmentCategoryEnum,
  HouseCategoryEnum,
  LandCategoryEnum,
  OfficeCategoryEnum,
  TypeEnum,
} from "@/types/types";

type CategoryEnum =
  | ApartmentCategoryEnum
  | HouseCategoryEnum
  | LandCategoryEnum
  | OfficeCategoryEnum;

const categoryEnumMap: Record<TypeEnum, object> = {
  [TypeEnum.APARTMENT]: ApartmentCategoryEnum,
  [TypeEnum.HOUSE]: HouseCategoryEnum,
  [TypeEnum.LAND]: LandCategoryEnum,
  [TypeEnum.OFFICE]: OfficeCategoryEnum,
  [TypeEnum.APARTMENT_HOUSE]: {},
  [TypeEnum.DEFAULT]: {},
};

export function getCategoryOptions(type: TypeEnum): CategoryEnum[] {
  return Object.values(categoryEnumMap[type]) as CategoryEnum[];
}
